import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import RefillScreen from ".";
import CreateRefillCategoryScreen from "./create";
import UpdateRefillCategoryScreen from "./update";
import DoctorsRefillCategoryScreen from "./doctors";
import { DoctorsRefillCategoriesProvider } from "../../../hooks/useDoctorsRefillCategories";

export default function RefillLayout() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={RefillScreen} />
      <Route
        exact
        path={`${path}/create`}
        component={CreateRefillCategoryScreen}
      />
      <Route
        exact
        path={`${path}/update`}
        component={UpdateRefillCategoryScreen}
      />
      <DoctorsRefillCategoriesProvider>
        <Switch>
          <Route
            exact
            path={`${path}/doctors`}
            component={DoctorsRefillCategoryScreen}
          />
        </Switch>
      </DoctorsRefillCategoriesProvider>

      {/* Catch-all */}
      <Redirect to={path} />
    </Switch>
  );
}
